import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { IdentityChallengeContext } from './contextDoNotImport';

export function PassthroughIdentityChallengeContext({ children }) {
  const dummyValue = useMemo(() => ({
    viewType: null,
    challengeFlowCollection: null,
    challengeFlowCollectionLoading: false,
    challengeFlowCollectionRefreshError: null,
    isAttemptingToCloseRemediation: false,
    handleClose() {},
    handleConfirmClose() {},
    handleSuccess() {},
    challengeFlowResource() {},
    setChallengeFlowCollection() {},
    refreshChallengeFlowCollection() {},
    handleInterceptResponse(collection, successCb) {
      return successCb(collection);
    },
    handleAttemptToCloseRemediation() {},
  }), []);
  return (
    <IdentityChallengeContext.Provider value={dummyValue}>
      {children}
    </IdentityChallengeContext.Provider>
  );
}

PassthroughIdentityChallengeContext.propTypes = {
  children: PropTypes.node.isRequired,
};
